import { render, staticRenderFns } from "./LampMtap2V1ControllerTelemetryCard.vue?vue&type=template&id=b1626bba&scoped=true&"
import script from "./LampMtap2V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./LampMtap2V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./LampMtap2V1ControllerTelemetryCard.vue?vue&type=style&index=0&id=b1626bba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1626bba",
  null
  
)

export default component.exports